import './jetton-topbar.scss';

import NiceModal from '@ebay/nice-modal-react';
import { CircleHelp, CirclePlus, History, ShieldCheck } from 'lucide-react';
import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/app/store/hooks';
import { selectJettonServerSeedHash } from '@/entities/jetton';
import { selectOnlineCountByGame } from '@/entities/rolls';
import { selectUserBalance } from '@/entities/user';
import TonIcon from '@/shared/assets/icons/ton.svg?react';
import { ROUTES } from '@/shared/config/constants';
import { MODALS } from '@/shared/config/modals';

const selectJettonOnlineCount = selectOnlineCountByGame('jetton');

const showHowItWorks = () => NiceModal.show(MODALS.JETTON_HOW_IT_WORKS);

export const JettonTopbar = memo(() => {
  const navigate = useNavigate();
  const balance = useAppSelector(selectUserBalance);
  const onlineCount = useAppSelector(selectJettonOnlineCount);
  const serverSeedHash = useAppSelector(selectJettonServerSeedHash);

  const showProvablyFair = useCallback(() => {
    NiceModal.show(MODALS.PROVABLY_FAIR, { serverSeedHash, game: 'jetton' });
  }, [serverSeedHash]);

  return (
    <div className="jetton-page__topbar jetton-page__topbar--in">
      <div className="jetton-page__topbar-left">
        <button
          type="button"
          className="jetton-page__topbar-btn jetton-page__topbar-btn--tappable"
          onClick={() => navigate(ROUTES.JETTON_HISTORY)}>
          <History className="jetton-page__topbar-btn-icon" />
        </button>
        <button
          type="button"
          className="jetton-page__topbar-btn jetton-page__topbar-btn--tappable"
          onClick={showHowItWorks}>
          <CircleHelp className="jetton-page__topbar-btn-icon" />
        </button>
      </div>

      <div className="jetton-page__topbar-center">
        <span className="jetton-page__online-dot" />
        <span className="jetton-page__online-count">{onlineCount}</span>
        <span className="jetton-page__online-label">online</span>
      </div>

      <div className="jetton-page__topbar-right-group">
        <button
          type="button"
          className="jetton-page__topbar-btn jetton-page__topbar-btn--tappable"
          onClick={showProvablyFair}>
          <ShieldCheck className="jetton-page__topbar-btn-icon jetton-page__topbar-btn-icon--shield" />
        </button>
        <div
          className="jetton-page__topbar-right jetton-page__topbar-right--tappable"
          onClick={() => navigate(ROUTES.PROFILE)}>
          <TonIcon className="jetton-page__topbar-ton-icon" />
          <span className="jetton-page__topbar-balance">{balance.toFixed(2)}</span>
          <CirclePlus className="jetton-page__topbar-plus-icon" />
        </div>
      </div>
    </div>
  );
});
